import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { IProiect } from '../../proiecte.interface';

@Component({
    selector: 'app-actiuni-proiect-card',
    templateUrl: './actiuni-proiect-card.component.html',
    styleUrls: ['./actiuni-proiect-card.component.scss']
})
export class ActiuniProiectCardComponent {
    @Input() title!: string;
    @Input() description!: string;
    @Input() iconName!: string;
    @Input() btnColor: string = 'warn';
    @Input() actionText!: string;
    @Input() actionType!: string;
    @Input() iconColor?: string = 'red';
    @Input() isSelected?: boolean = false;
    @Input() proiect?: IProiect;
    @Output() buttonClicked = new EventEmitter<string>();
    @Output() buttonResetClicked = new EventEmitter<string>();

    onButtonClick() {
        this.buttonClicked.emit(this.actionText);
    }

    onButtonResetClick() {
        console.log('xxxx', this.actionText)
        this.buttonResetClicked.emit(this.actionText);
    }

    toggleSelected() {
        this.isSelected = !this.isSelected;
    }

    constructor(
        public permissionsService: PermissionsService,
    ) { }

    selectedClass() {
        switch (this.actionType) {
            case 'inchidere':
                return this.proiect?.validated_date !== null ? true : false;
            case 'anulare':
                return this.proiect?.cancel_date !== null ? true : false;
            default:
                return false;
        }
    }
}
